import React from 'react'
import About from './About';
import Service from './Service';
import PromoArea from './PromoArea';
import Customers from './Customers';
import NavBar from './Navbar';

export default class Main extends React.Component {

  componentDidMount() {
    window.jqueryOnReady()
  }

  render() {

    return (<div>

            <NavBar></NavBar>

            <About showContact ></About>

            <Service></Service>

            <PromoArea></PromoArea>

            <Customers></Customers>
    </div>)
  }
}